import React from "react"
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitDiscover.module.scss"
// import styled from 'styled-components'

const RecruitDiscover = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "d" },
    { "id": 1, "text": "i" },
    { "id": 2, "text": "s" },
    { "id": 3, "text": "c" },
    { "id": 4, "text": "o" },
    { "id": 5, "text": "v" },
    { "id": 6, "text": "e" },
    { "id": 6, "text": "r" },
  ];

  return (
      <div className={styles.RecruitDiscover}>
        <div className={styles.RecruitDiscover__inner}>
          <TitleAnimation data={title1} className={`titleRubikCenter`} />
          <h2 className={`subH2`}>深川養鶏をもっと知る</h2>
            <div className={styles.RecruitDiscover__content}>
                <ul>
                  <li>
                    <a href="/business/">
                      <StaticImage
                        layout="fullWidth"
                        src="../../images/recruit/top/discover1@2x.png"
                        alt="business"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="/companyoutline/">
                      <StaticImage
                        layout="fullWidth"
                        src="../../images/recruit/top/discover2@2x.png"
                        alt="companyoutline"
                      />
                    </a>
                  </li>
                </ul>
            </div>
        </div>
      </div>
  )
}
export default RecruitDiscover

